// src/pages/About.js
import React from 'react';

function About() {
    return (
        <div>
            <h2>About Page</h2>
            <p>This is the About Page!</p>
        </div>
    );
}

export default About;